import React from "react";
import { Link } from "react-router-dom";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { logout, getOrganizationName } from "../../store/actions/authAction";
import { refreshAll } from "../../store/actions/initAction";

import LogoWithVersion from "../../components/common/LogoWithVersion";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import withStyles from '@mui/styles/withStyles';
import AccountCircle from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/HomeRounded";

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import history from '../../history/history';
import { RefreshRounded } from "@mui/icons-material";
import { ListItemButton } from "@mui/material";
import AccountSwitcher from "../../components/common/AccountSwitcher";

const sanitizeOrganizationName = value => {
	if (typeof value !== "string") {
		return value;
	}

	const trimmed = value.trim().toLowerCase();
	if (trimmed.startsWith("<!doctype") || trimmed.startsWith("<html")) {
		return "";
	}

	return value;
};

const styles = theme => ({
	root: {
		width: "100%",
		display: 'flex',
	},
	grow: {
		flexGrow: 1
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20
	},
	title: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block"
		}
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex"
		}
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none"
		}
	},
	button: {
		margin: theme.spacing(1)
	},
	
	  appBar: {
		zIndex: theme.zIndex.drawer + 1,
	  },
	  drawer: {
		width: drawerWidth,
		flexShrink: 0,
	  },
	  drawerPaper: {
		width: drawerWidth,
	  },
	  content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	  },
	  toolbar: theme.mixins.toolbar,
	  list: {
		width: 250,
	  },
	  fullList: {
		width: 'auto',
	  },
});
const drawerWidth = 240;
class Header extends React.Component {
	state = {
		anchorEl: null,
		mobileMoreAnchorEl: null
	};
	
	componentDidMount() {
		// Récupérer le nom de l'organisation lorsque l'utilisateur est authentifié
		if (this.props.auth.isAuthenticated) {
			this.props.getOrganizationName();
		}
	}
	
	componentDidUpdate(prevProps) {
		// Récupérer le nom de l'organisation si l'utilisateur vient de se connecter
		if (!prevProps.auth.isAuthenticated && this.props.auth.isAuthenticated) {
			this.props.getOrganizationName();
		}
	}
	
	handleProfileMenuOpen = event => {
		console.log('==========IN == handleProfileMenuOpen ========================');
		console.log({event});
		console.log('====================================');

		this.setState({ anchorEl: event.currentTarget });
	};

	handleMenuClose = () => {
		this.setState({ anchorEl: null });
		this.handleMobileMenuClose();
	};

	handleMobileMenuOpen = event => {
		this.setState({ mobileMoreAnchorEl: event.currentTarget });
	};

	handleMobileMenuClose = () => {
		this.setState({ mobileMoreAnchorEl: null });
	};
	goToHomePage = () => {
		console.log("GO TO MENU");
		let path = "/";
		history.push(path);
	}
	refresh = () => {
		this.props.refreshAll()
	}
	render() {
		// console.log("HEADER PROPS", this.props, size(this.props.cart));

		const { isAuthenticated, isAdmin, organizationName } = this.props.auth;
		const { anchorEl } = this.state;
		const { classes } = this.props;
		const isMenuOpen = Boolean(anchorEl);
		const rawOrganizationName =
			typeof organizationName === "string"
				? organizationName
				: organizationName?.organization_name || "";
		const resolvedOrganizationName = sanitizeOrganizationName(rawOrganizationName);

		const displayOrganizationName = isAuthenticated
			? (resolvedOrganizationName && resolvedOrganizationName !== "" ? resolvedOrganizationName : "--")
			: "";
		
		const userMenu = (
			<Menu
				id="material-appbar"
				anchorEl={anchorEl}
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				open={isMenuOpen}
				onClose={this.handleMenuClose}
			>
				{isAuthenticated &&
					<ListItemButton
						onClick={() => {
							history.push('/profile');
							this.handleMenuClose();
						}}
					>
						<ListItemText >
							Profil
						</ListItemText>
					</ListItemButton>
				}
				{/* {isAdmin &&
					<ListItemButton
						// component={Link}
						LinkComponent={Link}
						to="/society"
					>
						<ListItemText >
							Société
						</ListItemText>
					</ListItemButton>
				} */}
				{isAuthenticated &&
					<ListItem
						onClick={() => {
							this.handleMenuClose();	
							this.props.logout();
						}}
					>
						<ListItemText >
						Se Déconnecter
							
						</ListItemText>
					</ListItem>
				}			
				{!isAuthenticated &&
				<Link to={"/login"} >
					<ListItem>
						<ListItemText>
						Se Connecter							
						</ListItemText>
					</ListItem>
				</Link>
				}			
			</Menu>
		);

		// const renderMobileMenu = (
		// 	<SwipeableDrawer 
		// 		className={classes.drawer}
		// 		classes={{
		// 		paper: classes.drawerPaper,
		// 		}}
		// 		open={isMobileMenuOpen} onClose={this.handleMenuClose} anchorEl={mobileMoreAnchorEl} >
		// 		<div className={classes.toolbar}></div>
		// 		<List>

		// 		{commonLinks.map((link,index) => (
		// 		<Link className="" to={link.to} key={index}>
		// 			<ListItem button key={link.to}>
		// 				<ListItemIcon>{link.icon}</ListItemIcon>
		// 				<ListItemText >
		// 					{link.default}
		// 				</ListItemText>
		// 			</ListItem>
		// 		</Link>
		// 		))}
		// 		</List>

		// 	</SwipeableDrawer>
			
			  
		// );

		return (
            <div className={classes.root}>
				<AppBar position="fixed" color="primary" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
					<div className="max-view-width">
						<Toolbar>
							{/* <div className={classes.sectionMobile}>
								<IconButton onClick={this.handleMobileMenuOpen} className={classes.menuButton} color="inherit" aria-label="Menu">
									<MenuIcon />
								</IconButton>
							</div> */}
							<div className={classes.sectionMobile}>
								<div style={{ display: "flex", alignItems: "center" }}>
									<LogoWithVersion onLogoClick={this.goToHomePage} />
									{isAuthenticated && (
										<Typography
											component="span"
											variant="subtitle2"
											style={{ marginLeft: "12px", fontWeight: 500, color: "#000" }}
										>
											{displayOrganizationName}
										</Typography>
									)}
								</div>
							</div>

							<div className={classes.sectionDesktop}>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Typography
										className={classes.title}
										variant="h6"
										color="inherit"
										noWrap
										component="div"
									>
										<LogoWithVersion onLogoClick={this.goToHomePage} />
									</Typography>
									{isAuthenticated && (
										<Typography
											component="span"
											variant="subtitle1"
											style={{ marginLeft: "16px", fontWeight: 600, color: "#000" }}
										>
											{displayOrganizationName}
										</Typography>
									)}
								</div>
							</div>

							<div className={classes.grow} />
							
							{isAuthenticated && 
						<div style={{ display: 'flex', alignItems: 'center' }}>
							{/* <div className={classes.sectionMobile}> */}
							<Link className="" to="/">
								<IconButton size="large">
									<HomeIcon />
								</IconButton>
							</Link>
							{isAdmin &&
								<IconButton onClick={this.refresh} color="inherit" size="large">
									<RefreshRounded />
								</IconButton>
							}
							<AccountSwitcher />
							<IconButton
								aria-controls={isMenuOpen ? 'material-appbar' : undefined}
								aria-expanded={isMenuOpen}
                                    aria-haspopup="true"
                                    onClick={(e) => this.handleProfileMenuOpen(e)}
                                    color="inherit"
                                    size="large"
							>
								<AccountCircle />
							</IconButton>
						</div>
							
						}
							
						</Toolbar>
					</div>
				</AppBar>
				
				{userMenu}
			</div>
        );
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			logout,
			refreshAll,
			getOrganizationName,
		},
		dispatch
	);
}
Header.propTypes = {
	classes: PropTypes.object.isRequired
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(styles)(Header));
